import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { PartialVideoFormRequest, ReorderVideosResponse, Video, VideoSettingsControl, WithRelatedVideos } from '../interfaces/Video';

export async function getVideos(params?: { subjectId: string, programId: string }): Promise<StandardResponse<Video[]>> {
    const response: AxiosResponse<StandardResponse<Video[]>> = await api.get("/videos", {
        params
    });
    return response.data;
}

export async function getVideosByProgram(programId: string, params?: { keyword?: string }): Promise<StandardResponse<Video[]>> {
    const response: AxiosResponse<StandardResponse<Video[]>> = await api.get(`/videos/programs/${programId}`, {
        params
    });
    return response.data;
}

export async function getVideoById(id: string): Promise<StandardResponse<WithRelatedVideos>> {
    const response: AxiosResponse<StandardResponse<WithRelatedVideos>> = await api.get(`/videos/${id}`);
    return response.data;
}

export async function createVideo(request: PartialVideoFormRequest): Promise<StandardResponse<Video>> {
    const response: AxiosResponse<StandardResponse<Video>> = await api.post("/videos", request);
    return response.data;
}

export async function updateVideo(videoId: string, request: PartialVideoFormRequest): Promise<StandardResponse<Video>> {
    const response: AxiosResponse<StandardResponse<Video>> = await api.put(`/videos/${videoId}`, request);
    return response.data;
}

export async function deleteVideo(videoId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/videos/${videoId}`);
    return response.data;
}

export async function reorderVideos(request: { subjectId: string; videos: string[]; }): Promise<StandardResponse<ReorderVideosResponse>> {
    const response: AxiosResponse<StandardResponse<ReorderVideosResponse>> = await api.post("/videos/sequence", request);
    return response.data;
}

export async function getVimeoVideoUrlInfo(videoId: string): Promise<any> {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`, {
        headers: {
            Referer: window.location.origin
        }
    });
    const data = await response.json();
    return data;
}

export async function getVideoSettingsControl(): Promise<StandardResponse<VideoSettingsControl>> {
    const response: AxiosResponse<StandardResponse<VideoSettingsControl>> = await api.get("/videos/settings/controls");
    return response.data;
}

export async function updateVideoSettingsControl(request: { videoUrl?: boolean, videoUrl1?: boolean, videoUrl2?: boolean }): Promise<StandardResponse<VideoSettingsControl>> {
    const response: AxiosResponse<StandardResponse<VideoSettingsControl>> = await api.post("/videos/settings/controls", request);
    return response.data;
}